import { IAction, ISubDepartment } from '../../schemas';
import { GET_SUBDEPARTMENT_LIST, ADD_SUBDEPARTMENT, UPDATE_SUBDEPARTMENT, DELETE_SUBDEPARTMENT } from '../constant';

const initState: any = {};

export default function subDepartmentsReducer(
	preState = initState,
	action: IAction<any>
): any {
	const { type, data } = action;
	switch (type) {
		case GET_SUBDEPARTMENT_LIST:
			return { ...data };
		case ADD_SUBDEPARTMENT:
			const newdata = [...preState.data, data];
			return { data: newdata, total: preState.total };
		case UPDATE_SUBDEPARTMENT:
			const index = preState.data.findIndex(
				(item) => item.id === action.data.id
			);
			const updateData = [
				...preState.data.slice(0, index),
				{
					...data,
				},
				...preState.data.slice(index + 1),
			];
			return { data: updateData, total: preState.total };
		case DELETE_SUBDEPARTMENT:
			return {
				data: preState.data.filter((d) => d.id !== action.data.id),
				total: preState.total,
			};
		default:
			return preState;
	}
}
